import { RichText } from 'prismic-reactjs';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { ContentWrapper } from '../components/content_wrapper/content_wrapper';
import FishingReportsListContainer from '../components/fishing_reports_list/fishing_reports_list_container';
import { ScrollToTop } from '../components/scroll_to_top/scroll_to_top';
import { SEO } from '../components/seo/seo';
import { serializeHyperlink } from '../lib/serializers';
import { linkResolver } from '../prismic';
import { getPrismicPage } from '../redux/pages';
import styles from './fishing_reports_page.less';

export const FishingReportsPage: React.FC = (props) => {
  const page = useSelector(getPrismicPage);
  const location = useLocation();

  return (
    <ScrollToTop>
      <SEO title={page?.meta_title} description={page?.meta_description} />
      <section style={{ paddingBottom: 96 }}>
        <ContentWrapper>
          <div className={styles.content}>
            {page?.body.map((slice) => {
              switch (slice.slice_type) {
                case 'text': {
                  return (
                    <RichText
                      key={`${slice.primary.text[0].text}:${slice.primary.text.length}`}
                      render={slice.primary.text}
                      linkResolver={linkResolver as any}
                      serializeHyperlink={serializeHyperlink as any}
                    ></RichText>
                  );
                }
              }
            })}
          </div>

          <FishingReportsListContainer query={location.search} />
        </ContentWrapper>
      </section>
    </ScrollToTop>
  );
};
